<template>
  <div class="productSort">
    <div class="board-table">
      <div class="board-header-ms" @click="handleBoardClick('msVisiable')">
        盟市
        <img v-if="!this.visiableFlags.msVisiable" class="board-arrow" src="@assets/images/arrow-up.png"/>
        <img v-if="this.visiableFlags.msVisiable" class="board-arrow" src="@assets/images/arrow-down.png"/>
      </div>
      <transition name="fade">
        <el-table
            id="ms"
            :data="billboardData.msBillboard"
            stripe
            size="mini"
            fit="true"
            v-if="this.visiableFlags.msVisiable"
            transiton="fade"
            style="width: 100%">
          <el-table-column
              type="index"
              align="center"
              label="排名">
          </el-table-column>
          <el-table-column
              type="index"
              align="center">
            <template slot-scope="scope">
              <img :src="'/static/billboard/'+scope.row.leagueId+'.png'"
                   class="league-ranking-img"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="leagueName"
              align="center"
              label="名称">
          </el-table-column>
          <el-table-column
              align="center"
              label="本期参与率">
            <template slot-scope="scope">
              {{ scope.row.percent + '%' }}
            </template>
          </el-table-column>
          <el-table-column
              label="与上周对比"
              align="center">
            <template slot-scope="scope">
              <span :class="getBoardColor(scope.row.percent,scope.row.lastWeekPercent)">
              {{ parseInt(scope.row.percent - scope.row.lastWeekPercent) + '%' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </transition>


      <div class="board-header-bk" @click="handleBoardClick('bkVisiable')">
        本科院校
        <img v-if="!this.visiableFlags.bkVisiable" class="board-arrow" src="@assets/images/arrow-up.png"/>
        <img v-if="this.visiableFlags.bkVisiable" class="board-arrow" src="@assets/images/arrow-down.png"/>
      </div>
      <transition name="fade">
        <el-table
            :data="billboardData.bkBillboard"
            stripe
            v-if="this.visiableFlags.bkVisiable"
            transiton="fade"
            size="mini"
            fit="true"
            style="width: 100%">
          <el-table-column
              type="index"
              align="center"
              label="排名">
          </el-table-column>
          <el-table-column
              type="index"
              align="center">
            <template slot-scope="scope">
              <img :src="'/static/billboard/'+scope.row.leagueId+'.png'"
                   class="league-ranking-img"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="leagueName"
              align="center"
              label="名称">
          </el-table-column>
          <el-table-column
              align="center"
              label="本期参与率">
            <template slot-scope="scope">
              {{ scope.row.percent + '%' }}
            </template>
          </el-table-column>
          <el-table-column
              label="与上周对比"
              align="center">
            <template slot-scope="scope">
              <span :class="getBoardColor(scope.row.percent,scope.row.lastWeekPercent)">
              {{ parseInt(scope.row.percent - scope.row.lastWeekPercent) + '%' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </transition>


      <div class="board-header-gz" @click="handleBoardClick('gzVisiable')">
        高职院校
        <img v-if="!this.visiableFlags.gzVisiable" class="board-arrow" src="@assets/images/arrow-up.png"/>
        <img v-if="this.visiableFlags.gzVisiable" class="board-arrow" src="@assets/images/arrow-down.png"/>
      </div>
      <transition name="fade">
        <el-table
            :data="billboardData.gzBillboard"
            stripe
            v-if="this.visiableFlags.gzVisiable"
            transiton="fade"
            size="mini"
            fit="true"
            style="width: 100%">
          <el-table-column
              type="index"
              align="center"
              label="排名">
          </el-table-column>
          <el-table-column
              type="index"
              align="center">
            <template slot-scope="scope">
              <img :src="'/static/billboard/'+scope.row.leagueId+'.png'"
                   class="league-ranking-img"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="leagueName"
              align="center"
              label="名称">
          </el-table-column>
          <el-table-column
              align="center"
              label="本期参与率">
            <template slot-scope="scope">
              {{ scope.row.percent + '%' }}
            </template>
          </el-table-column>
          <el-table-column
              label="与上周对比"
              align="center">
            <template slot-scope="scope">
              <span :class="getBoardColor(scope.row.percent,scope.row.lastWeekPercent)">
              {{ parseInt(scope.row.percent - scope.row.lastWeekPercent) + '%' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </transition>


      <div class="board-header-qy" @click="handleBoardClick('qyVisiable')">
        企业
        <img v-if="!this.visiableFlags.qyVisiable" class="board-arrow" src="@assets/images/arrow-up.png"/>
        <img v-if="this.visiableFlags.qyVisiable" class="board-arrow" src="@assets/images/arrow-down.png"/>
      </div>
      <transition name="fade">
        <el-table
            :data="billboardData.qyBillboard"
            stripe
            v-if="this.visiableFlags.qyVisiable"
            transiton="fade"
            size="mini"
            fit="true"
            style="width: 100%">
          <el-table-column
              type="index"
              align="center"
              label="排名">
          </el-table-column>
          <el-table-column
              type="index"
              align="center">
            <template slot-scope="scope">
              <img :src="'/static/billboard/'+scope.row.leagueId+'.png'"
                   class="league-ranking-img"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="leagueName"
              align="center"
              label="名称">
          </el-table-column>
          <el-table-column
              align="center"
              label="本期参与率">
            <template slot-scope="scope">
              {{ scope.row.percent + '%' }}
            </template>
          </el-table-column>
          <el-table-column
              label="与上周对比"
              align="center">
            <template slot-scope="scope">
              <span :class="getBoardColor(scope.row.percent,scope.row.lastWeekPercent)">
              {{ parseInt(scope.row.percent - scope.row.lastWeekPercent) + '%' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </transition>


      <div class="board-header-qx" @click="handleBoardClick('qxVisiable')">
        旗县市区
        <img v-if="!this.visiableFlags.qxVisiable" class="board-arrow" src="@assets/images/arrow-up.png"/>
        <img v-if="this.visiableFlags.qxVisiable" class="board-arrow" src="@assets/images/arrow-down.png"/>
      </div>
      <transition name="fade">
        <el-table
            :data="billboardData.qxBillboard"
            stripe
            v-if="this.visiableFlags.qxVisiable"
            transiton="fade"
            size="mini"
            fit="true"
            style="width: 100%">
          <el-table-column
              type="index"
              align="center"
              label="排名">
          </el-table-column>
          <el-table-column
              type="index"
              align="center">
            <template slot-scope="scope">
              <img :src="'/static/billboard/'+scope.row.leagueId+'.png'"
                   class="league-ranking-img"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="leagueName"
              align="center"
              label="名称">
          </el-table-column>
          <el-table-column
              align="center"
              label="本期参与率">
            <template slot-scope="scope">
              {{ scope.row.percent + '%' }}
            </template>
          </el-table-column>
          <el-table-column
              label="与上周对比"
              align="center">
            <template slot-scope="scope">
              <span :class="getBoardColor(scope.row.percent,scope.row.lastWeekPercent)">
              {{ parseInt(scope.row.percent - scope.row.lastWeekPercent) + '%' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </transition>

      <div class="board-header-qt" @click="handleBoardClick('qtVisiable')">
        其它
        <img v-if="!this.visiableFlags.qtVisiable" class="board-arrow" src="@assets/images/arrow-up.png"/>
        <img v-if="this.visiableFlags.qtVisiable" class="board-arrow" src="@assets/images/arrow-down.png"/>
      </div>
      <transition name="fade">
        <el-table
            :data="billboardData.qtBillboard"
            stripe
            v-if="this.visiableFlags.qtVisiable"
            transiton="fade"
            size="mini"
            fit="true"
            style="width: 100%">
          <el-table-column
              type="index"
              align="center"
              label="排名">
          </el-table-column>
          <el-table-column
              type="index"
              align="center">
            <template slot-scope="scope">
              <img :src="'/static/billboard/'+scope.row.leagueId+'.png'"
                   class="league-ranking-img"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="leagueName"
              align="center"
              label="名称">
          </el-table-column>
          <el-table-column
              align="center"
              label="本期参与率">
            <template slot-scope="scope">
              {{ scope.row.percent + '%' }}
            </template>
          </el-table-column>
          <el-table-column
              label="与上周对比"
              align="center">
            <template slot-scope="scope">
              <span :class="getBoardColor(scope.row.percent,scope.row.lastWeekPercent)">
              {{ parseInt(scope.row.percent - scope.row.lastWeekPercent) + '%' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </transition>

    </div>

  </div>
</template>
<script>
import {qryBillboard} from "@api/lesson";

export default {
  name: "LeagueBoard",
  components: {},
  props: {},
  data: function () {
    return {
      billboardData: {},
      visiableFlags: {
        msVisiable: true,
        bkVisiable: true,
        gzVisiable: true,
        qyVisiable: true,
        qxVisiable: true,
        qtVisiable: true
      }
    };
  },
  mounted: function () {
    this.initBillboard();
  },
  methods: {
    initBillboard() {
      let loading = this.$weui.loading("数据加载中");
      let that = this;
      qryBillboard().then(res => {
        that.billboardData = res;
      });
      loading.hide();
    },
    handleBoardClick(id) {
      // console.log(id + ':' + this.visiableFlags[id]);
      if (this.visiableFlags[id] === true) {
        this.visiableFlags[id] = false;
      } else {
        this.visiableFlags[id] = true;
      }
    },
    getBoardColor(thisWeek, lastWeek) {
      if (thisWeek - lastWeek > 0) {
        return "board-color-green";
      } else {
        return "board-color-red";
      }
    }
  },
  filters: {
    ellipsis(value, limit) {
      if (!value) return "";
      if (value.length > limit) {
        return value.slice(0, limit) + "...";
      }
      return value;
    },
  }
};
</script>
<style>
.league-ranking-img {
  width: 12vw;
  border-radius: 50%;
  overflow: hidden;
}

.board-table {
  width: 95vw;
  margin-left: 2.5vw;
  margin-top: 2vh;
  margin-bottom: 7vh;
}

.board-header-ms {
  position: revert;
  height: 5vh;
  width: 100%;
  background-color: #fc666a;
  /*background-image: url("../../assets/images/billboard-ms.png");*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 30% 8%;
  font-size: larger;
  color: #f6f6f6;
  font-weight: bolder;
  text-align: center;
}

.board-header-bk {
  height: 5vh;
  width: 100%;
  background-color: #fca773;
  /*background-image: url("../../assets/images/billboard-bk.png");*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 30% 8%;
  font-size: larger;
  color: #f6f6f6;
  font-weight: bolder;
  text-align: center;
}

.board-header-gz {
  height: 5vh;
  width: 100%;
  background-color: #e8d027;
  /*background-image: url("../../assets/images/billboard-gz.png");*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 30% 8%;
  font-size: larger;
  color: #f6f6f6;
  font-weight: bolder;
  text-align: center;
}

.board-header-qy {
  height: 5vh;
  width: 100%;
  background-color: #99ee99;
  /*background-image: url("../../assets/images/billboard-qy.png");*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 30% 8%;
  font-size: larger;
  color: #f6f6f6;
  font-weight: bolder;
  text-align: center;
}

.board-header-qx {
  height: 5vh;
  width: 100%;
  background-color: #72e2ec;
  /*background-image: url("../../assets/images/billboard-qx.png");*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 30% 8%;
  font-size: larger;
  color: #f6f6f6;
  font-weight: bolder;
  text-align: center;
}

.board-header-qt {
  height: 5vh;
  width: 100%;
  background-color: #8086fb;
  /*background-image: url("../../assets/images/billboard-qt.png");*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 30% 8%;
  font-size: larger;
  color: #f6f6f6;
  font-weight: bolder;
  text-align: center;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.board-arrow {
  position: absolute;
  right: 4vw;
  width: 6vw;
}

.board-color-green {
  color: limegreen;
}

.board-color-red {
  color: red;
}
</style>
